import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import Session from 'components/SessionReplica';
import Footer from 'components/MiniFooter';
import Header from 'components/StaticPageHeader';
import NavOnScroll from 'components/NavOnScroll';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import { logPageView, initGA } from 'utils/analytics';
import PropTypes from 'prop-types';
import styles from './Sports.scss';// to import local scss fle

class Sports extends Component {
  static propTypes = {
    attributes: PropTypes.shape(),
  };
  static defaultProps = {
    attributes: {},
  };
  constructor(props) {
    super(props);
    this.state = {
      showFixedNavbar: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    initGA();
          logPageView(this.props.match.path); // eslint-disable-line

    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const scrollTop = event.srcElement.body.scrollTop;
    if (scrollTop > 80) {
      this.setState({ showFixedNavbar: true });
    } else {
      this.setState({ showFixedNavbar: false });
    }
  }
  render() {
    return (
      <div className={cn('row')}>
        <Helmet>
          <title>MyRecruitBoard – Get Recruited. Unmatched Social Media Exposure!</title>
          <meta name="description" content="College Football Recruiting Unmatched Social Media Exposure!" />
          <meta name="Keywords" content="RECRUITING Exposure,Largest Football Recruiting, NCAA D1, D2, D3, NAIA, & JUCO College Coaches" />
        </Helmet>
        {this.state.showFixedNavbar === true ? <NavOnScroll {...this.props} /> : ''}
        <div className={cn('col s12', styles.header)}>
          <Header page="sports" {...this.props} />
        </div>
        <div className={cn('col s12', styles.sportsWeSupport)}>
          <div className={cn('col s12 m6', styles.imageContainer)}>
            <img alt="football" src="https://media.dev.myrecruitboard.com/Images/myrb-sports-pic1.jpg" />
          </div>
          <div className={cn('col s12 m6')}>
            <div className={styles.bigHeader}>The Largest Football
                Recruiting Account on Twitter</div>
            <div className={styles.darkHeader}>GET RECRUITED TODAY!</div>
            <div className={styles.desc}>
                We have the largest college football recruiting account on Twitter.
                Unlike other major national football recruiting companies we provide exposure
                to every level of college football.  MyRecruitBoard does all of this without
                charging your family hundreds or even worse thousands of dollars. <br />
                NCAA D1, D2, D3, NAIA, & JUCO College Coaches direct message us everyday
                looking for their next recruit.
            </div>
            {this.props.attributes.size > 0 ? '' :
            <Link to="/register">
              <button className={styles.createProfile}>JOIN NOW</button>
            </Link>
              }
          </div>
          <div className={cn('col s12 m6', styles.imageContainerInSmall)}>
            <img alt="football" src="https://media.dev.myrecruitboard.com/Images/myrb-sports-pic1.jpg" />
          </div>
        </div>
        <div className={cn('col s12', styles.footerContainer)}>
          <Footer />
        </div>
      </div>
    );
  }
}


export default Session(Sports);



// WEBPACK FOOTER //
// ./src/containers/Sports/Sports.js